const nps = {
  nps: {
    npsBreakdown: 'NPS-uitsplitsing',
    npsScore: 'NPS-score',
    npsSpread: 'NPS-Spreiding',
    npsDashboard: 'NPS DASHBOARD',
    npsDetails: 'NPS details',
    npsTrend: 'NPS-trend',
    verbatims: 'Ontvangen beoordelingen',
    timePeriod: 'Tijdsperiode : ',
    to: 'naar',
    pastMonths: 'Afgelopen %{month} Maanden',
    ratingType: 'Beoordelingstype',
    systemId: 'Systeem-ID',
    systemName: 'Systeemnaam',
    rating: 'Beoordeling',
    comments: 'Opmerkingen',
    all: 'Allemaal',
    promoter: 'Promotor',
    promoters: 'Promoters',
    detractor: 'Critici',
    detractors: 'Critici',
    passive: 'Passief',
    noData: 'Geen gegevens beschikbaar',
    npsDashboardTooltip: {
      whatIs: 'Wat is de Net Promotor Score?',
      npsDefine:
        'De Net Promotor Score is een index variërend van -100 tot 100 die de bereidheid van klanten meet om een bedrijf aan te bevelen aan anderen. Het wordt gebruikt als een proxy voor het meten van de algemene tevredenheid van de klant.',
      questionIs: `De vraag is geformuleerd als volgt: "Op een schaal van 0 tot 10, hoe groot acht u de kans dat u onze organisatie zou aanbevelen aan een vriend of collega? Op basis van het nummer dat een klant kiest, worden ze ingedeeld in een van de volgende categorieën: "Critici", "Passievelingen" en "Promotors". Score-uitsplitsingen: 0 - 6: Critici, 7 - 8: Passievelingen, 9 - 10: Promoters.`,
      determined: `De Net Promotor Score (NPS) wordt bepaald door het percentage klanten dat negatieve publiciteit veroorzaakt, af te trekken van het percentage dat een positieve invloed heeft. Wat wordt gegenereerd is een score tussen -100 en 100 die de Net Promotor Score wordt genoemd.`,
      how: `Hoe bepaalt Enphase de NPS voor u?`,
      shownBelow: `Enphase vraagt huiseigenaren om beoordelingen te geven in de Enlighten Mobile app zoals weergegeven in de onderstaande schermen. Op basis van de gegeven waarderingen wordt de NPS bepaald zoals hierboven beschreven.`
    },
    timePeriodTooltip: `De standaardtermijn is de afgelopen 13 maanden. Als de NPS-score niet beschikbaar is voor de afgelopen 13 maanden, dan wordt de score opgenomen vanaf de eerste beschikbare maand.`,
    verbatimsTooltip: `Alle systeemeigenaren die toestemming hebben gegeven voor het vrijelijk delen van feedback aan installateurs worden hier getoond.`,
    jan: "Jan'",
    feb: "Feb'",
    mar: "Mar'",
    apr: "Apr'",
    may: "Mei'",
    jun: "Juni'",
    jul: "Jul'",
    aug: "Aug'",
    sep: "Sep'",
    oct: "Okt'",
    nov: "Nov'",
    dec: "Dec'",
    ofTotal: 'in totaal',
    ratings: 'Beoordelingen',
    numberOfReviews: 'Aantal beoordelingen',
    date: 'Datum',
    between0And10: 'Gelieve een waarde tussen 0 en 10 in te voeren',
    lessThan50: 'Het aantal karakters moet minder dan 50 zijn',
    npsBasedOnScore: `NPS van %{score} gebaseerd op %{count} waarderingen`
  }
};

export default nps;
